import React, { useEffect, useState } from 'react';
import ComboMultiple from '../../../../../shared/components/Combos/Multiple';
import { createOptions } from './functions';
import Flag from 'react-flagkit';
import { EuiFlexGroup, EuiFlexItem } from '@elastic/eui';

export const ComboPaises = (props:any) =>{

  let {options, selectedOptions, onChange} = props;
  let [comboOptions, setComboOptions] = useState(options)

  useEffect(()=>{
    if(options){
      setComboOptions(createOptions(options))
    }
  },[options])

  useEffect(()=>{
    if(comboOptions && comboOptions.length>0)
    {
      let select = !Array.isArray(selectedOptions) ? comboOptions.filter((o:any) => o.value===selectedOptions) : selectedOptions
      onChange && onChange(select)
    }
  },[comboOptions])

  const onCreateOption = (searchValue:any, flattenedOptions = []) => {
    if (!searchValue) {
      return;
    }

    const normalizedSearchValue = searchValue.trim().toLowerCase();

    if (!normalizedSearchValue) {
      return;
    }

    const newOption = {
      value: searchValue,
      label: searchValue,
    };

    // Create the option if it doesn't exist.
    if (
      flattenedOptions.findIndex(
        (option:any) => option.label.trim().toLowerCase() === normalizedSearchValue
      ) === -1
    ) {
      options.push(newOption);
      setComboOptions([...options, newOption]);
    }

    // Select the option.
    onChange && onChange([...selectedOptions, newOption])
  };

  const renderOption = (option:any, searchValue:any, contentClassName:any) => {
    const { label, value } = option;
    return (
      <EuiFlexGroup>
      <EuiFlexItem grow={false}>
        <Flag country={value} />
      </EuiFlexItem>
      <EuiFlexItem>
        <span>{label}</span>
      </EuiFlexItem>
      </EuiFlexGroup>
    );
  };

  return (
    <ComboMultiple {...{...props,...{options:(comboOptions),renderOption:renderOption,onCreateOption:onCreateOption}}} id="comboPaises"/>
  )
}
export default ComboPaises